import React from 'react';
import { FORMAT_DATE } from '@/constants/date-formats';
import { chargeCenterRoute } from '@/modules/charge-center/route';
import { createRoute } from '@tanstack/react-router';
import { formatDate } from 'date-fns';
import { z } from 'zod';

const dateSchema = z.string().regex(/^\d{2}-\d{2}-\d{4}$/, 'Date must be in DD-MM-YYYY format');

const transactionSearchSchema = z.object({
  page: z.coerce.number().min(1).default(1), // * Page number
  size: z.coerce.number().min(50).default(50), // * Page size
  from: dateSchema.default(() => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    return formatDate(date, FORMAT_DATE);
  }), // * Start date for the transaction
  to: dateSchema.default(() => formatDate(new Date(), FORMAT_DATE)), // * End date for the transaction
  sort: z
    .enum([
      'timestamp-start',
      'timestamp-stop',
      'odometer',
      'soc-start',
      'soc-stop',
      'soh',
      'total-energy',
      'avg-power',
      'max-power',
    ])
    .default('timestamp-start'), // * Sort by
  order: z.enum(['asc', 'desc']).default('desc'), // * Sort order
  hide: z.array(z.string()).optional(), // * Columns to hide
  asset: z.array(z.string()).optional(), // * Filter by asset
  txn: z.string().optional(), // * Filter by transaction ID
  veh: z.string().optional(), // * Filter by vehicle ID
  odo: z.string().optional(), // * Filter by odometer value
  start: z.string().optional(), // * Filter by SoC initial
  stop: z.string().optional(), // * Filter by SoC final
  soh: z.string().optional(), // * Filter by SoH
  nrg: z.string().optional(), // * Filter by total energy
  avg: z.string().optional(), // * Filter by average power
  max: z.string().optional(), // * Filter by maximum power
});

// ! Reminder that this doesn't work as expected, must be redone afterwards
export const assetsTransactionsRoute = createRoute({
  getParentRoute: () => chargeCenterRoute,
  path: 'assets-transactions',
  component: React.lazy(
    async () => await import('@/app/routes/Admin/transactions/transaction-list')
  ),
  wrapInSuspense: true,
  validateSearch: transactionSearchSchema,
});
